import { useEffect, useState } from "react";
import { Loader2, MessageSquareText } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, formatErr } from "@/lib/api";

export function ExpiryTextOptIn() {
  const [n, setN] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/me/notifications").then((r) => setN(r.data)).catch(() => {}); }, []);
  if (!n || n.sms_expiry) return null;
  const save = async () => {
    setBusy(true);
    try { setN((await api.put("/me/notifications", { phone: n.phone, sms_alerts: n.sms_alerts, sms_reminders: n.sms_reminders, sms_expiry: true })).data); toast.success("Done. We'll text you 7 days before each expiry."); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-3 border-t border-slate-100 pt-3" data-testid="expiry-text-optin">
      <p className="text-sm text-slate-700 flex items-center gap-2"><MessageSquareText className="h-4 w-4 text-emerald-600" />Get a text 7 days before anything expires</p>
      <div className="flex flex-col sm:flex-row gap-2 mt-2">
        <Input placeholder="Mobile number, e.g. 555 123 4567" value={n.phone || ""} onChange={(e) => setN({ ...n, phone: e.target.value })} className="h-10 sm:max-w-xs" data-testid="expiry-text-phone" />
        <Button onClick={save} disabled={busy || !n.phone} variant="outline" className="h-10" data-testid="expiry-text-save">{busy && <Loader2 className="h-4 w-4 mr-1 animate-spin" />}Text me</Button>
      </div>
      <p className="text-[11px] text-slate-400 mt-1.5">You agree to automated texts from GrantVerify. Message & data rates may apply. Reply STOP to opt out.</p>
    </div>
  );
}
